import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgPc({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 3a3 3 0 012.995 2.824L21 6v8a3 3 0 01-2.824 2.995L18 17h-4a1 1 0 100 2h1a1 1 0 110 2H9a1 1 0 110-2h1a1 1 0 100-2H6a3 3 0 01-2.995-2.824L3 14V6a3 3 0 012.824-2.995L6 3h12zm0 2H6a1 1 0 00-.993.883L5 6v8a1 1 0 00.883.993L6 15h12a1 1 0 00.993-.883L19 14V6a1 1 0 00-.883-.993L18 5z"
        fill={color}
      />
    </svg>
  )
}

export default SvgPc
